export const STATUS_TOKENS = {
  QUEUED: { bg: "rgba(100,116,139,0.15)", text: "#CBD5E1", border: "#475569", label: "EN COLA" },
  PROCESSING: { bg: "rgba(14,165,233,0.15)", text: "#FF4D4D", border: "#B0101C", label: "PROCESANDO" },
  ANALYZING: { bg: "rgba(168,85,247,0.15)", text: "#C084FC", border: "#7E22CE", label: "ANALIZANDO" },
  OCR: { bg: "rgba(245,158,11,0.15)", text: "#FBBF24", border: "#D97706", label: "OCR" },
  DETECTING: { bg: "rgba(6,182,212,0.15)", text: "#FF3B3B", border: "#B0101C", label: "DETECTANDO" },
  RECONSTRUCTING: { bg: "rgba(99,102,241,0.15)", text: "#818CF8", border: "#4F46E5", label: "RECONSTRUYENDO" },
  EXPORTING: { bg: "rgba(236,72,153,0.15)", text: "#F472B6", border: "#DB2777", label: "EXPORTANDO" },
  COMPLETED: { bg: "rgba(16,185,129,0.15)", text: "#34D399", border: "#059669", label: "COMPLETADO" },
  CANCELLED: { bg: "rgba(244,63,94,0.15)", text: "#FB7185", border: "#E11D48", label: "CANCELADO" },
  FAILED: { bg: "rgba(239,68,68,0.2)", text: "#F87171", border: "#DC2626", label: "FALLIDO" },
};

export const StatusBadge = ({ status }) => {
  const t = STATUS_TOKENS[status] || STATUS_TOKENS.QUEUED;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className="inline-flex items-center px-2.5 py-1 rounded text-[11px] font-mono font-medium tracking-wide"
      style={{ backgroundColor: t.bg, color: t.text, border: `1px solid ${t.border}` }}
    >
      {t.label}
    </span>
  );
};

export const RoleBadge = ({ role }) => {
  const map = {
    SUPER_ADMIN: { c: "#F59E0B", b: "#D97706" },
    ADMIN: { c: "#FF4D4D", b: "#B0101C" },
    USER: { c: "#94A3B8", b: "#475569" },
  };
  const t = map[role] || map.USER;
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded text-[11px] font-mono"
      style={{ color: t.c, border: `1px solid ${t.b}`, backgroundColor: `${t.c}18` }}>
      {role}
    </span>
  );
};
